import React from 'react'
import {
    Button,
    Card,
    Col,
    Divider,
    Empty,
    Image,
    Input,
    message,
    Popconfirm,
    Row,
    Skeleton,
    Space,
    Spin,
    Tabs,
    Typography
} from 'antd'
import {withRouter} from 'react-router'
import {getArtwork, getArtworkAdmin, getArtworkById} from '../../api/artworks'

import '../../asset/less/Pieces.less'
import HttpError from '../base/HttpError'
import {
    deleteArtworkCollection,
    getArtworkCollection,
    getArtworkCollectionAdmin,
    patchArtworkCollection
} from '../../api/artworkCollections'
import {getArtworkDetailUrl, getArtworkInfoUrl, getEditUrl, sanity_s3_url_display} from '../Utils'
import {connect} from 'react-redux'
import {DeleteOutlined, EditOutlined, EyeInvisibleOutlined} from '@ant-design/icons'
import {URL_EDIT_COLLECTIONS_ID, URL_EDIT_PIECES_ID, URL_NEW_COLLECTIONS} from '../../const'
import ArtworkSortButton from "../piece/ArtworkSortButton";
import GalleryTablePanel from "../GalleryTablePanel";
import AddPrimaryButton from "../base/AddPrimaryButton";
import MyPagination from "../MyPagination";
import CollectionSortButton from "./CollectionSortButton";
import {is_admin_user} from "../../app/role";
import {artworkAllColumns, artworkColumns} from "../piece/ArtworkColumns";

const {Title} = Typography
const {Meta} = Card
const {Link} = Typography

@connect((state) => ({
    //decorator, gives component access to the state
    userId: state.user.info.id,
    artistId: state.user.info.artistId,
    email: state.user.info.email,
    role: state.user.info.role
}))
class ArtworkCollectionPanel extends React.Component {
    constructor(props) {
        super(props)
        this.prefix = 'ArtworkCollection'
        this.query = new URLSearchParams(this.props.location.search)
        let pageSize = this.loadCache('pageSize' + this.props.artistId) || props.pageSize
        let currentPage = this.loadCache('current' + this.props.artistId) || props.current
        let orderBy = this.loadCache('orderBy' + this.props.artistId) || props.defaultSortOption

        try {
            pageSize = pageSize == null ? 12 : parseInt(pageSize)
        } catch (e) {
            pageSize = 12
        }

        try {
            currentPage = currentPage == null ? 1 : parseInt(currentPage)
        } catch (e) {
            currentPage = 1
        }

        orderBy = orderBy == null ? '-created_at' : orderBy

        this.state = {
            loading: false,
            dataSource: [],
            orderBy: orderBy,
            pageSize: pageSize,
            current: currentPage,
            total: 0,
            showImage: true,
            collections: []
        }

        this.columns = [
            {
                title: '#',
                dataIndex: 'id',
                key: 'id'
            },
            {
                title: 'Image',
                dataIndex: 'static_url',
                key: 'static_url',
                render: (text, record) => <Image src={record.static_url}/>
            },
            {
                title: 'Artwork Name',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => (
                    <a target='_blank'
                       href={'https://revart.co/artworks/info/' + getArtworkInfoUrl(record.id, record.name)}
                       rel='noreferrer'>
                        {text}
                    </a>
                )
            },
            {
                title: 'H"',
                dataIndex: 'height',
                key: 'height'
            },
            {
                title: 'W"',
                dataIndex: 'width',
                key: 'width'
            },
            {
                title: 'D"',
                dataIndex: 'depth',
                key: 'depth'
            },
            {
                title: 'Year',
                dataIndex: 'year',
                key: 'year',
                render: (text, record) => {
                    if (!text || text === -1 || text === '-1') {
                        return ""
                    }
                    try {
                        return parseInt(text)
                    } catch (e) {
                        return ""
                    }
                }
            },
            {
                title: 'Style',
                dataIndex: 'style',
                key: 'style'
            },
            {
                title: 'Medium',
                dataIndex: 'medium',
                key: 'medium'
            },
            {
                title: 'Materials',
                dataIndex: 'material',
                key: 'material'
            },
            {
                title: 'Subject',
                dataIndex: 'subject',
                key: 'subject'
            },
            {
                title: 'Tags',
                dataIndex: 'tag',
                key: 'tag'
            },
            {
                title: 'Price',
                dataIndex: 'price',
                key: 'price'
            },
            {
                title: 'Business',
                dataIndex: 'used_type',
                key: 'used_type'
            }
        ]
    }

    setCache(key, value) {
        localStorage.setItem(this.prefix + '_' + key, value)
    }

    loadCache(key) {
        try {
            return localStorage.getItem(this.prefix + '_' + key).toString()
        } catch (e) {
            return ""
        }
    }

    removeCache(key) {
        localStorage.removeItem(this.prefix + '_' + key)
    }

    componentDidMount() {
        this.updateData()
    }

    componentWillUnmount() {
    }

    onPaginationChange(page) {
        this.setState(
            {
                current: page
            },
            this.updateData
        )
        this.setCache('currentPage' + this.props.artistId, page)
    }

    onShowSizeChange(current, pageSize) {
        this.setState(
            {
                current: 1,
                pageSize: pageSize
            },
            this.updateData
        )
        this.setCache('currentPage' + this.props.artistId, 1)
        this.setCache('pageSize' + this.props.artistId, pageSize)
    }

    getArtworksByCollection = async (images) => {
        const imageArray = Array.from(images)
        if (imageArray.length > 10) {
            this.setState({
                showImage: false
            })
        }
        const results = await Promise.all(
            imageArray.map((image) => {
                return getArtworkById(image)
            })
        )

        const dataSource = data.map((collection) => {
            return {
                id: collection.id,
                artworks: collection.artworks.map((artwork) => {
                    const image = results[imageArray.findIndex((value) => value === artwork)]?.data
                    return {
                        title: image.name,
                        id: image.id,
                        s3_url: image.s3_url,
                        static_url: image.static_url
                    }
                }),
                title: collection.title,
                artworks_order_json: collection.artworks_order_json,
                is_visible: collection.is_visible,
                created_at: collection.created_at,
                updated_at: collection.updated_at
            }
        })
        this.setState({
            loading: false,
            dataSource: dataSource,
        })
    }

    updateData = () => {
        this.setState({loading: true})
        const request_func = is_admin_user(this.props) ? getArtworkCollectionAdmin : getArtworkCollection
        request_func(this.state.current, this.state.pageSize, this.props.artistId, this.state.orderBy, this.state.search)
            .then(async (response) => {
                const images = new Set()
                const data = response.data.results.map((item) => {
                    item.artworks.map((artwork) => {
                        images.add(artwork)
                    })
                    return {
                        id: item.id,
                        artworks: item.artworks,
                        title: item.title,
                        artworks_order_json: item.artworks_order_json,
                        is_visible: item.is_visible,
                        created_at: item.created_at,
                        updated_at: item.updated_at,
                    }
                })
                this.setState({
                    dataSource: data,
                    total: response.data.count
                })
            })
            .catch((error) => {
                if (error && error.response && error.response.status && error.response.status !== 404) {
                    HttpError(error)
                }
            }).finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    collectionItemLayout = (collection) => {
        const items = []
        const getCover = (item) => {
            if (!this.state.showImage) {
                return null
            }
            return (
                <Image
                    src={sanity_s3_url_display(item.static_url)}
                    preview={{
                        src: sanity_s3_url_display(item.s3_url)
                    }}
                    alt={item.name}
                />
            )
        }
        collection.artworks.map((element, index) => {
            items.push(
                <Col xs={12} sm={8} md={6} key={index}>
                    <Card
                        loading={this.state.loading}
                        style={{
                            marginBottom: '20px'
                        }}
                        cover={!this.state.loading && getCover(element)}
                        actions={[
                            <EditOutlined
                                key={0}
                                style={{color: '#0531ad'}}
                                onClick={(event) => {
                                    if (!this.state.loading) {
                                        this.props.history.push({
                                            pathname: getEditUrl(URL_EDIT_PIECES_ID, element.id)
                                        })
                                    }
                                }}
                            />,
                            <DeleteOutlined
                                key={1}
                                style={{marginLeft: 6}}
                                onClick={() => {
                                    this.removeData(element.id)
                                }}
                            />
                        ]}
                    >
                        <Row justify='space-between' align='middle'>
                            <Meta
                                title={
                                    <div style={{width: '100%', padding: 4}}>
                    <span
                        style={{
                            display: 'block',
                            fontSize: 12,
                            width: '100%'
                        }}
                    >
                      {'# ' + element.id}
                    </span>
                                        <Divider style={{padding: 0, margin: 4}}/>
                                        <a
                                            target={'_blank'}
                                            href={getArtworkDetailUrl(element.id, element.title)}
                                            style={{
                                                overflowWrap: 'anywhere',
                                                fontSize: 14,
                                                maxWidth: '80%'
                                            }}
                                            rel='noreferrer'
                                        >
                                            {' '}
                                            {element.title}
                                        </a>
                                    </div>
                                }
                            />
                        </Row>
                    </Card>
                </Col>
            )
        })
        return (
            <div>
                <Divider/>
                <Row justify='flex-start' gutter={{xs: 8, sm: 16, md: 24}} style={{marginTop: '16px'}}>
                    {items}
                </Row>
            </div>
        )
    }

    getArtworkFullUrl = (element) => {
        return 'https://revart.co/artworks/info/' + getArtworkInfoUrl(element.id, element.name)
    }

    getEditUrl = (element) => {
        if (!element.id) {
            return
        }

        return getEditUrl(URL_EDIT_PIECES_ID, element.id)
    }

    getActionLayout = (collection) => {
        return (
            <Row
                style={{width: '100%'}}
                gutter={{
                    xs: 8,
                    sm: 16,
                    md: 24,
                    lg: 32
                }}
            >
                <Col xs={24} sm={24} md={24}>
                    <Space style={{float: 'right', marginLeft: 'auto', marginRight: '3vw', flexWrap: 'wrap'}}>
                        <Button style={{verticalAlign: 'center'}} icon={<EditOutlined/>}
                                href={getEditUrl(URL_EDIT_COLLECTIONS_ID, collection.id)}>
                            Edit
                        </Button>
                        <Button
                            icon={<EyeInvisibleOutlined/>}
                            onClick={() => {
                                patchArtworkCollection(collection.id, {is_visible: !collection.is_visible})
                                    .then((response) => {
                                        const source = this.state.dataSource
                                        const target = source.filter((item) => item.id === collection.id)
                                        if (target.length > 0) {
                                            const index = source.indexOf(target[0])
                                            if (index > -1) source[index].is_visible = !collection.is_visible
                                            this.setState({
                                                dataSource: source
                                            })
                                        }
                                    })
                                    .catch((error) => {
                                        HttpError(error)
                                    })
                            }}
                        >
                            Set as {collection.is_visible ? 'private' : 'public'}
                        </Button>
                        <Popconfirm
                            title='Are you sure to delete this collection?'
                            onConfirm={() => {
                                deleteArtworkCollection(collection.id)
                                    .then(() => {
                                        const dataSource = this.state.dataSource.filter((c) => {
                                            return c.id !== collection.id
                                        })
                                        this.setState({
                                            dataSource
                                        })
                                        message.success('Delete successfully!').then((r) => {
                                        })
                                    })
                                    .catch((error) => {
                                        HttpError(error)
                                    })
                            }}
                            okText='Yes'
                            cancelText='No'
                        >
                            <Button danger icon={<DeleteOutlined/>} style={{color: 'red', marginLeft: 'auto'}}>
                                Delete
                            </Button>
                        </Popconfirm>
                    </Space>
                </Col>
            </Row>
        )
    }

    render() {
        const layoutByView = () => {
            if (this.state.dataSource?.length !== 0) {
                return (
                    <Tabs
                        type='card'
                        size={'small'}
                        defaultActiveKey={0}
                        tabPosition={'top'}
                        onChange={(e) => {
                            console.log(e)
                        }}
                        items={this.state.dataSource?.map((collection, i) => {

                            const requestData = (current, pageSize, order, filters, search, requestDataToken) => {
                                const requestFunc = is_admin_user(this.props) ? getArtworkAdmin : getArtwork
                                return requestFunc(
                                    current,
                                    pageSize,
                                    order,
                                    search,
                                    this.props.artistId,
                                    {
                                        ...filters,
                                        collectionFilter: collection.id,
                                    },
                                    requestDataToken
                                )
                            }

                            return {
                                label: collection.is_visible ? (
                                    <span>{"#" + (i + 1) + " " + collection.title}</span>
                                ) : (
                                    <span
                                        style={{textDecoration: 'line-through'}}>{"#" + (i + 1) + " " + collection.title}</span>
                                ),
                                key: collection.id,
                                children: (
                                    <GalleryTablePanel artistId={this.props.artistId}
                                                       role={this.props.role}
                                                       disableAdd={true}
                                                       disableImport={true}
                                                       name={'piece'} nameSuffix={" of <" + collection.title + ">"}
                                                       topActionLayout={this.getActionLayout(collection)}
                                                       dataOrderJson={collection.artworks_order_json}
                                                       requestData={requestData}
                                                       columns={artworkColumns}
                                                       allColumns={artworkAllColumns} tableWidth={1200}
                                                       excludedColumns={['static_url']}
                                                       defaultSortOption={'-created_at'}
                                                       sortLayout={ArtworkSortButton}
                                                       filtersLayout={this.getFiltersPanel}
                                                       getEditUrl={this.getEditUrl}
                                                       getOpenUrl={this.getArtworkFullUrl}
                                                       deleteData={null}
                                                       exportOptions={['excel', 'inventory_report', 'qr_code']}/>
                                )
                            }
                        })}
                    />
                )
            } else if (this.state.loading) {
                return <Row>
                    <Skeleton/>
                    <Skeleton/>
                    <Skeleton/>
                </Row>
            } else {
                return <Empty/>
            }
        }
        const layout = layoutByView()

        return (
            <Spin size='large' spinning={this.state.loading}>
                <div className='site-layout-background'>
                    <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}}>
                        <Col>
                            <Title style={{marginBottom: 0}}>{this.state.total} Collections</Title>
                        </Col>
                        <Col style={{paddingTop: 12, marginLeft: 'auto', marginRight: 4, float: 'right'}}>
                            <AddPrimaryButton
                                onClick={() => {
                                    this.props.history.push({pathname: URL_NEW_COLLECTIONS})
                                }}
                            />
                        </Col>
                    </Row>
                    <Row style={{paddingTop: '4vh', paddingBottom: '4vh'}}>
                        <div style={{
                            width: '100%', paddingLeft: '4vw', paddingRight: '4vw',
                            display: 'flex', marginLeft: 'auto', marginRight: 'auto', justifyContent: 'center',
                            gap: 4, flexWrap: 'wrap'
                        }}>
                            <MyPagination
                                style={{marginTop: 4}}
                                showSizeChanger={true}
                                total={this.state.total}
                                current={this.state.current}
                                defaultPageSize={this.state.pageSize}
                                pageSize={this.state.pageSize}
                                onChange={this.onPaginationChange.bind(this)}
                                onShowSizeChange={this.onShowSizeChange.bind(this)}
                            />
                            <CollectionSortButton order={this.state.orderBy} onChange={(value) => {
                                this.setState({orderBy: value, current: 1}, this.updateData)
                            }}/>
                            <Col style={{marginTop: 4, float: 'right'}}>
                                <Input.Search
                                    defaultValue={this.state.search}
                                    placeholder='Search Collection'
                                    onSearch={(value) => {
                                        this.setState(
                                            {
                                                search: value,
                                                current: 1
                                            },
                                            this.updateData
                                        )
                                    }}
                                />
                            </Col>
                        </div>
                    </Row>
                    <div style={{marginBottom: 12, marginTop: 12}}/>
                    {layout}
                </div>
            </Spin>
        )
    }
}

export default withRouter(ArtworkCollectionPanel)
